exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.password-width[data-v-5bd8a23a] {\n  width: 370px;\n  margin-left: 10px;\n  margin-top: 10px;\n}\n.confirm-button-container[data-v-5bd8a23a] {\n  text-align: right;\n}\n", ""]);

// exports
